// Tiny localStorage-backed cache for stale-while-revalidate page loads.
//
// Goal: navigating to Today / Dashboard / Contacts should paint the
// last-known state INSTANTLY from cache (no loading-blank flash), then
// revalidate over the network in the background. When the data hasn't
// changed (the common case — these update only on a poll), callers gate on a
// version token (e.g. the dashboard's `built_at`) and skip re-rendering
// entirely, so there's no flicker. When it HAS changed, the arrays update in
// place and Svelte's keyed reconciliation transitions smoothly.
import { isSupportView } from './supportView';

export function readCache<T>(key: string): T | null {
  if (isSupportView()) return null;
  try {
    const v = localStorage.getItem(key);
    return v ? (JSON.parse(v) as T) : null;
  } catch {
    return null;
  }
}

export function writeCache(key: string, val: unknown): void {
  if (isSupportView()) return;
  try {
    localStorage.setItem(key, JSON.stringify(val));
  } catch {
    // Quota / private-mode / serialization failure — caching is best-effort.
  }
}
